<template>
  <div class="checkout-builder-draggable-elements">
    <h4 class="px-5 mb-5 text-neutral-500">
      Arraste e solte os elementos nas áreas desejadas
    </h4>

    <div class="elements-container">
      <draggable
        v-for="element in elements"
        handle=".handle"
        :key="element.type"
        :group="{ name: 'components', put: false, pull: 'clone' }"
        @end="onDragEnd"
        @start="() => onDragStart(element)"
      >
        <div class="draggable-element handle">
          <div class="d-flex" v-if="Array.isArray(element.icon)">
            <bp-icon
              class="text-neutral-900"
              v-for="icon in element.icon"
              size="38"
              weight="200"
              :key="icon"
              :icon="icon"
            />
          </div>
          <bp-icon
            v-else
            size="38"
            weight="200"
            class="text-neutral-900"
            :icon="element.icon"
          />

          <div class="text-neutral-600">{{ element.label }}</div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import elements from "./elements";

export default {
  components: { draggable },
  data() {
    return {
      elements
    };
  },
  methods: {
    onDragStart(element) {
      this.$store.commit("checkoutBuilder/setElement", element.type);
    },
    onDragEnd() {
      this.$store.commit("checkoutBuilder/setElement", null);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-draggable-elements {
  .elements-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    .draggable-element {
      gap: 12px;
      padding: 12px;
      display: flex;
      user-select: none;
      border-radius: 4px;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      background: var(--Surface-Cumulative-plus8, rgba(255, 255, 255, 0.32));
      border: 1px solid var(--Semantic-Neutral-048, rgba(215, 215, 215, 0.48));

      transition: 0.2s all;
      &:hover {
        cursor: move;
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;
        backdrop-filter: blur(12px);
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.12);
        border: 1px solid var(--Semantic-Primary-Accent-400, #9849ff);
        background: var(--Surface-Cumulative-plus16, rgba(255, 255, 255, 0.64));
      }
      &:active {
        cursor: grabbing;
        cursor: -moz-grabbing;
        cursor: -webkit-grabbing;
        backdrop-filter: blur(8px);
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
        border: 1px solid var(--Semantic-Primary-Accent-600, #6700ee);
        background: var(--Surface-Cumulative-plus20, rgba(255, 255, 255, 0.8));
      }
    }
  }
}
</style>
